import Box from '@mui/material/Box';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import './FrozenAccountAlert.css';

const FrozenAccountAlert = ({ children }) => {
    return (
        <Box className="frozen-account-alert">
            <Box display="flex" alignItems="center">
                <CancelOutlinedIcon color="error" sx={{ paddingRight: '9px' }} />
                <Box className="frozen-account-alert-message">{children}</Box>
            </Box>
        </Box>
    );
};

export default FrozenAccountAlert;
